export const apiHost = process.env.API_HOST;
// export const wcpHost = 'http://170.64.190.76:1340';
// export const dleHost = 'http://170.64.190.76:1350';
export const defaultTimeout = 3000; // ms